import { motion } from "framer-motion";
import SectionLabel from "@/components/sections/SectionLabel";

export default function Vision() {
  return (
    <section
      id="vision"
      data-testid="vision-section"
      className="relative py-28 md:py-40 border-t border-border overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[500px] rounded-full opacity-60"
          style={{
            background:
              "radial-gradient(ellipse at center, hsl(var(--accent) / 0.10), transparent 70%)",
            filter: "blur(40px)",
          }}
        />
      </div>

      <div className="relative max-w-4xl mx-auto px-6 md:px-10 text-center">
        <SectionLabel>The future</SectionLabel>
        <motion.h2
          data-testid="vision-statement"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-display font-semibold mt-6 text-balance text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-[-0.025em]"
        >
          Software quality should improve with every commit —
          <span className="text-muted-foreground">
            {" "}
            not become more expensive.
          </span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="mt-8 text-base md:text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed"
        >
          Liskov AI is building autonomous Product Quality Engineers that continuously
          understand your product, reason about change, explore your application like
          real customers, and protect every release.
        </motion.p>
      </div>
    </section>
  );
}
